import {
  CSSProperties,
  JSXElementConstructor,
  ReactElement,
  useMemo,
} from 'react';

import styled, { useTheme } from 'styled-components';

import Tooltip, { TooltipProps } from '@components/ui/Tooltip/next';
import { useDevice } from '@contexts/device';

type Props = {
  children: ReactElement<any, string | JSXElementConstructor<any>> | undefined;
  showTooltip?: boolean;
} & Partial<TooltipProps>;

const StyledTooltip = styled.div`
  & .rc-tooltip {
    z-index: 10 !important;
  }
`;

const LimitSeturPointsEarnTooltip = ({
  children,
  trigger = 'click',
  ...others
}: Props) => {
  const { palette } = useTheme();
  const { isMobile } = useDevice();

  const InnerOverlayStyles = useMemo<CSSProperties>(() => {
    return {
      backgroundColor: palette.NL0,
      color: palette.D400,
      padding: '8px',
      borderRadius: '8px',
      textAlign: 'center',
      width: isMobile ? '220px' : '250px',
      height: '52px',
      lineHeight: '17px',
      fontWeight: '300',
      whiteSpace: 'normal',
    };
  }, [palette, isMobile]);

  return (
    <StyledTooltip>
      <Tooltip
        title='Bir rezervasyondan en fazla 4.000 TL Setur Puan kazanılabilir.'
        placement='top'
        arrowColor='white'
        getPopupContainer={(node) => node}
        overlayInnerStyle={InnerOverlayStyles}
        trigger={trigger}
        {...others}
      >
        {children}
      </Tooltip>
    </StyledTooltip>
  );
};

export default LimitSeturPointsEarnTooltip;
